import { render, staticRenderFns } from "./BookingNotifyManagersModal.vue?vue&type=template&id=550bb38c"
import script from "./BookingNotifyManagersModal.vue?vue&type=script&lang=js"
export * from "./BookingNotifyManagersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports